import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/shared/lib/auth/auth-context'
import { canSeeDatalakeDashboards } from '@/shared/lib/auth/tenant-constants'
import { reportingLevel } from '../../report-access'

interface ReportsRouteProps {
  /** The lowest `Reporting.Custom` level that may see the page (15, 30 ...). */
  minLevel: number
  children: ReactNode
}

/** Guards the saved-reports routes: datalake tenants only, and at least `minLevel` (UC-104 BR7). */
export function ReportsRoute({ minLevel, children }: ReportsRouteProps) {
  const { user } = useAuth()
  if (!canSeeDatalakeDashboards(user) || reportingLevel(user) < minLevel) {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}
